import React from 'react'
import { useStateValue } from '@State'
import PropTypes from 'prop-types'

export const DeductionFields = props => {
  const [currentState, dispatch] = useStateValue()

  const deleteDeduction = () => {
    let deductions = [...currentState.defaultDeductions]
    deductions.splice(props.deductionIndex, 1)
    dispatch({ type: 'modifyDeductions', defaultDeductions: deductions })
  }

  const handleChange = (deductionPosition, value) => {
    let deductions = [...currentState.defaultDeductions]
    let replacementValue = deductions[props.deductionIndex]
    replacementValue.splice(deductionPosition, 1, value)
    deductions.splice(props.deductionIndex, 1, replacementValue)
    dispatch({ type: 'modifyDeductions', defaultDeductions: deductions })
  }

  return (
    <div>
      <div className="d-flex">
        <input
          className="maxw-40px mr-2"
          type="text"
          value={props.timeValue}
          onChange={e => handleChange(0, e.target.value)}
        />
        <select
          className="form-control maxw-25"
          value={props.timeUnit}
          onChange={e => handleChange(1, e.target.value)}
        >
          <option value="d">Day(s)</option>
          <option value="h">Hour(s)</option>
          <option value="m">Minute(s)</option>
        </select>
        <span className="my-auto ml-2">late</span>
        <i className="fa-light fa-long-arrow-right mx-3 my-auto fa-2x" />
        <input
          className="maxw-40px mr-2"
          type="text"
          value={props.pointValue}
          onChange={e => handleChange(2, e.target.value)}
        />
        <select
          className="form-control maxw-25"
          value={props.pointUnit}
          onChange={e => handleChange(3, e.target.value)}
        >
          <option value="points">Percent</option>
          <option value="percent">Points</option>
        </select>
        <span className="my-auto ml-2">deduction</span>
        {props.allowDelete && (
          <i
            className="fa-light fa-times-circle mt-4 ml-2 pointer"
            onClick={deleteDeduction}
          />
        )}
      </div>
    </div>
  )
}

DeductionFields.propTypes = {
  timeValue: PropTypes.string,
  timeUnit: PropTypes.string,
  pointValue: PropTypes.string,
  pointUnit: PropTypes.string,
  allowAdd: PropTypes.bool,
  allowDelete: PropTypes.bool,
  deductionIndex: PropTypes.number,
}
